import { useState } from 'react';

const ProductTabs = () => {
  const [activeTab, setActiveTab] = useState('detail');

  const specifications = [
    { label: '제품명', value: '로지텍 G PRO X 기계식 게이밍 키보드' },
    { label: '제조사', value: 'Logitech' },
    { label: '스위치 타입', value: 'GX Blue Clicky (교체 가능)' },
    { label: '키 레이아웃', value: '텐키리스 (87키)' },
    { label: '연결 방식', value: '유선 USB (탈착식 케이블)' },
    { label: '백라이트', value: 'RGB 라이트싱크 (1,680만 컬러)' },
    { label: '폴링 레이트', value: '1000Hz (1ms)' },
    { label: '키 롤오버', value: 'N-Key Rollover' },
    { label: '안티 고스팅', value: '지원' },
    { label: '프레임 재질', value: '항공기급 알루미늄 합금' },
    { label: '키캡 재질', value: 'PBT 더블샷' },
    { label: '케이블 길이', value: '1.8m (탈착식)' },
    { label: '소프트웨어', value: 'Logitech G HUB' },
    { label: '매크로 지원', value: '지원 (프로그래밍 가능)' },
    { label: '크기', value: '361 x 153 x 34mm' },
    { label: '무게', value: '980g' },
    { label: '보증 기간', value: '2년' },
    { label: '원산지', value: '중국' },
    { label: '인증', value: 'KC 인증' }
  ];

  const reviews = [
    {
      id: 1,
      author: '프로게이머K',
      rating: 5,
      date: '2024-12-15',
      content: 'FPS 게임용으로 구매했는데 반응속도가 정말 빠릅니다. 클릭감도 명확하고 RGB 조명도 화려해서 만족스럽습니다. 텐키리스라 마우스 공간도 넓어졌어요.'
    },
    {
      id: 2,
      author: '개발자L',
      rating: 5,
      date: '2024-12-10',
      content: '코딩용으로 사용 중인데 타건감이 정말 좋습니다. 장시간 타이핑해도 손목이 편하고, 스위치 교체가 가능해서 나중에 다른 스위치로 바꿔볼 수 있어 좋네요.'
    },
    {
      id: 3,
      author: '디자이너M',
      rating: 4,
      date: '2024-12-05',
      content: '디자인 작업할 때 단축키 많이 쓰는데 매크로 기능이 정말 유용합니다. 다만 청축이라 소음이 좀 있어서 사무실에서는 조심스럽네요.'
    },
    {
      id: 4,
      author: '스트리머N',
      rating: 5,
      date: '2024-11-28',
      content: '방송용으로 구매했는데 RGB 조명이 화면에 잘 나와서 시청자들 반응이 좋습니다. 빌드 퀄리티도 탄탄하고 프리미엄 느낌이 납니다.'
    },
    {
      id: 5,
      author: '학생O',
      rating: 5,
      date: '2024-11-20',
      content: '첫 기계식 키보드인데 정말 만족합니다. 타건감이 중독성 있고, 게임할 때 반응속도가 확실히 빨라진 느낌입니다. 가격 대비 최고예요!'
    }
  ];

  return (
    <div className="w-full">
      <div className="flex border-b border-gray-200 mb-8">
        <button
          onClick={() => setActiveTab('detail')}
          className={`px-6 py-3 font-semibold transition-colors whitespace-nowrap cursor-pointer ${
            activeTab === 'detail'
              ? 'text-teal-600 border-b-2 border-teal-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          상품 상세
        </button>
        <button
          onClick={() => setActiveTab('specs')}
          className={`px-6 py-3 font-semibold transition-colors whitespace-nowrap cursor-pointer ${
            activeTab === 'specs'
              ? 'text-teal-600 border-b-2 border-teal-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          제품 사양
        </button>
        <button
          onClick={() => setActiveTab('reviews')}
          className={`px-6 py-3 font-semibold transition-colors whitespace-nowrap cursor-pointer ${
            activeTab === 'reviews'
              ? 'text-teal-600 border-b-2 border-teal-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          구매 후기
        </button>
      </div>

      {activeTab === 'detail' && (
        <div className="prose max-w-none">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">제품 특징</h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">프로 게이머를 위한 설계</h3>
              <p className="text-gray-700 leading-relaxed">
                로지텍 G PRO X는 프로 e스포츠 선수들과 협력하여 개발된 프리미엄 기계식 키보드입니다. 
                1000Hz 폴링 레이트와 1ms 응답 속도로 게임에서 결정적인 순간을 놓치지 않습니다.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">교체 가능한 스위치</h3>
              <p className="text-gray-700 leading-relaxed">
                GX Blue Clicky, GX Brown Tactile, GX Red Linear 중 원하는 스위치로 교체 가능합니다. 
                공구 없이 간편하게 스위치를 교체하여 자신만의 타건감을 만들 수 있습니다.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">프리미엄 빌드 퀄리티</h3>
              <p className="text-gray-700 leading-relaxed">
                항공기급 알루미늄 합금 프레임과 PBT 더블샷 키캡으로 내구성이 뛰어납니다. 
                탈착식 USB 케이블로 휴대성도 우수하며, 텐키리스 디자인으로 마우스 공간을 확보할 수 있습니다.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">RGB 라이트싱크</h3>
              <p className="text-gray-700 leading-relaxed">
                1,680만 컬러의 RGB 백라이트를 지원하며, Logitech G HUB 소프트웨어를 통해 
                키별로 조명을 커스터마이징할 수 있습니다. 다른 로지텍 G 제품과 조명을 동기화할 수도 있습니다.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg mt-8">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">추천 대상</h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>프로 게이머 및 e스포츠 선수</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>FPS, MOBA 등 경쟁 게임 플레이어</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>프리미엄 타건감을 원하는 개발자</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-600 mt-1 w-5 h-5 flex items-center justify-center"></i>
                  <span>커스터마이징을 즐기는 키보드 애호가</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'specs' && (
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">상세 사양</h2>
          <div className="border border-gray-200 rounded-lg overflow-hidden">
            <table className="w-full">
              <tbody>
                {specifications.map((spec, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="px-6 py-4 text-sm font-semibold text-gray-700 w-1/3 border-b border-gray-200">
                      {spec.label}
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-900 border-b border-gray-200">
                      {spec.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'reviews' && (
        <div>
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-bold text-gray-900">구매 후기</h2>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-yellow-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                ))}
              </div>
              <span className="text-lg font-bold text-gray-900">4.8</span>
              <span className="text-sm text-gray-500">(128개 후기)</span>
            </div>
          </div>

          <div className="space-y-6">
            {reviews.map((review) => (
              <div key={review.id} className="border-b border-gray-200 pb-6 last:border-b-0">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <span className="font-semibold text-gray-900">{review.author}</span>
                    <div className="flex items-center gap-1">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i
                          key={star}
                          className={`${
                            star <= review.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'
                          } text-sm w-4 h-4 flex items-center justify-center`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <span className="text-sm text-gray-500">{review.date}</span>
                </div>
                <p className="text-gray-700 leading-relaxed">{review.content}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductTabs;